import {
  Box as Flex,
  Typography as Text,
  makeStyles,
  styled,
} from '@material-ui/core';

import classNames from 'classnames';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { ActivityItem } from '@spotify/plugin-confidence-activity-react';

import type { Rule } from './types';

const EnvironmentChip = styled(Text)({
  background: 'var(--background-base)',
  display: 'inline-flex',
  padding: 'var(--encore-spacing-tighter-4) var(--encore-spacing-tighter-2)',
  borderRadius: 'var(--encore-corner-radius-base)',
});

const useStyles = makeStyles({
  added: {
    color: 'var(--essential-positive)',
    background: 'var(--background-positive-subdued-base)',
  },
  removed: {
    color: 'var(--text-subdued)',
    textDecoration: 'line-through',
  },
});

export const EnvironmentsSection = ({
  oldRule,
  newRule,
}: {
  oldRule?: Rule;
  newRule?: Rule;
}) => {
  const classes = useStyles();

  if (!oldRule?.environments?.length && !newRule?.environments?.length) {
    return null;
  }

  const oldEnvironments =
    oldRule?.environments?.map(environment => environment.name) ?? [];
  const newEnvironments =
    newRule?.environments?.map(environment => environment.name) ?? [];
  const environments = Array.from(
    new Set([...oldEnvironments, ...newEnvironments]),
  );

  return (
    <ActivityItem.Section label="Environments">
      <Flex
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        style={{
          gap: 'var(--encore-spacing-tighter-4)',
        }}
      >
        {environments.map(environment => (
          <EnvironmentChip
            key={environment}
            variant="body1"
            className={classNames({
              [classes.added]:
                newEnvironments.includes(environment) &&
                !oldEnvironments.includes(environment) &&
                oldRule &&
                newRule,
              [classes.removed]:
                oldEnvironments.includes(environment) &&
                !newEnvironments.includes(environment) &&
                oldRule &&
                newRule,
            })}
          >
            {extractLastNameComponent(environment)}
          </EnvironmentChip>
        ))}
      </Flex>
    </ActivityItem.Section>
  );
};
